import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { PaginateCargoTypesActions as PaginateActions } from 'store/ducks/cargoTypes';
import { usePaginationCache } from 'hooks';
import { Scaffold } from 'layouts';
import {
  TypesList,
  TypeFilters,
  FindCargoTypes,
} from 'components/Pages/CargoTypes';
import { Paginator, ListingPageHeader, SettingsMenu } from 'components/Shared';
import * as S from './styles';

export const CargoTypesListPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const { paginationCache, updatePaginationCache, handleFilter, handleSort } =
    usePaginationCache('cargoTypes');

  const {
    data: types,
    pagination,
    loading,
  } = useSelector((state: RootState) => state.paginateCargoTypes);

  const [query, setQuery] = useState<FindCargoTypes>({
    search: '',
    page: 1,
    limit: 10,
    ...paginationCache,
  });

  const onPageChange = useCallback((page: number): void => {
    setQuery((state) => ({ ...state, page }));
  }, []);

  const onQueryChange = useCallback((): void => {
    dispatch(PaginateActions.request(query));
  }, [dispatch, query]);

  useEffect(() => {
    onQueryChange();
  }, [onQueryChange]);

  useEffect(() => {
    return () => {
      dispatch(PaginateActions.reset());
      updatePaginationCache(query);
    };
  }, [dispatch, query, updatePaginationCache]);

  return (
    <Scaffold>
      <SettingsMenu />
      <S.MainPanel>
        <ListingPageHeader
          icon={<S.TruckIcon />}
          title="Tipos de cargas"
          isLoading={loading}
          actions={
            <S.LinkButton to={'/configuracoes/tipos-cargas/criar'} size="small">
              <S.PlusIcon /> Novo tipo de carga
            </S.LinkButton>
          }
        />
        <TypeFilters
          currentFilter={query}
          onFilter={(filter) => handleFilter(query, filter, setQuery)}
        />
        <TypesList
          currentSort={query}
          cargoTypes={types}
          onSort={(sort) => handleSort(query, sort, setQuery)}
        />
        <Paginator onPageChange={onPageChange} pagination={pagination} />
      </S.MainPanel>
    </Scaffold>
  );
};
